import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  automatedResponses: {
    id: 'app.containers.Chatbot.Automatedreponses.automatedResponses',
    defaultMessage: `Automated Responses`,
  },
});
